module.exports = __webpack_public_path__ + "assets/img/cat-small.c322eaf7.jpg";